module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"office":"Offices","pdp":"Privacy Policy","d":"Delegations","cg":"General conditions","pdc":"Cookies policy"},"es":{"office":"Oficinas","pdp":"Política de privacidad","d":"Delegaciones","cg":"Condiciones generales","pdc":"Política de cookies"}}')
  delete Component.options._Ctor
}
